import React from "react";
// noinspection JSUnusedLocalSymbols
function NavFooter(props) {
  return <></>;
}

NavFooter.propTypes = {};

export default NavFooter;
